import { Component, Input } from '@angular/core';

// GPS installed / status / mine location / vehicle last location shown under the vehicle dropdown
// on Dispatch Slip, Transit Pass and Weighbridge Dispatch. trackDets comes from VehicleGpsService.withLocations.
@Component({
  selector: 'app-vehicle-gps-info',
  templateUrl: './vehicle-gps-info.component.html',
  styleUrls: ['./vehicle-gps-info.component.scss']
})
export class VehicleGpsInfoComponent {
  @Input() trackDets: any;

  get gpsNotInstalled(): boolean {
    return this.trackDets?.vehiclestatustype == 0;
  }

  get status(): string {
    return this.trackDets?.status || this.trackDets?.vehiclestatus || '-';
  }

  hasPoint(lat: any, lng: any): boolean {
    return lat != null && lat !== '' && lng != null && lng !== '';
  }

  formatPoint(lat: any, lng: any): string {
    return `${parseFloat(lat).toFixed(6)}, ${parseFloat(lng).toFixed(6)}`;
  }

  mapLink(lat: any, lng: any): string {
    return `https://www.google.com/maps?q=${lat},${lng}`;
  }
}
